import { useEffect } from 'react';
import './UserProfile.css';
import { IUser, Logger } from '@desp-aas/desp-ui-fwk';
import { IProfileAssets, UserProfileAssets } from './UserProfileAssets';

const logger = new Logger("component", "userProfile");

type IProps = {
    assets: IProfileAssets
    loadingAssets: boolean
    fetchAssets: () => Promise<void>
}

export function UserAssets(props: IProps) {

    useEffect(() => {
        props.fetchAssets();
    }, []);

    return (

        <>
            <UserProfileAssets
                loading={props.loadingAssets}
                title="datasets" 
                type="dataset"
                assets={props.assets}
            />
            <UserProfileAssets
                loading={props.loadingAssets}
                title="models"
                type="model"
                assets={props.assets}
            />
            <UserProfileAssets
                loading={props.loadingAssets}
                title="applications"
                type="application"
                assets={props.assets}
            />
            <UserProfileAssets
                loading={props.loadingAssets}
                title="documents"
                type="paper"
                assets={props.assets}
            />
            <UserProfileAssets
                loading={props.loadingAssets}
                title="courses"
                type="course"
                assets={props.assets}
            />
        </>
    )
}
export default UserAssets;
